<style lang="scss" scoped>
</style>
<template>
  <div v-if="!item.hidden">
    <template v-if="item.children && hasChildrenShow(item.children)">
      <li class="el-menu-item title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="generateTitle(item.meta.title)"
        />
      </li>
      <ul class="child">
        <sidebar-item
          v-for="child in item.children"
          :key="child.path || child.id"
          :item="child"
          :base-path="resolvePath(item.path)"
        />
      </ul>
    </template>
	<li class="el-menu-item" v-else>
		<app-link :to="resolvePath(item.path)">
			<item
				:icon="item.meta.icon || (item.meta && item.meta.icon)"
				:title="generateTitle(item.meta.title)"
			/>
		</app-link>
	</li>
  </div>
</template>

<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
	name: 'SidebarItem',
	components: { Item, AppLink },
	mixins: [FixiOSBug],
	props: {
		// route object
		item: {
			type: Object,
			required: true
		},
		basePath: {
			type: String,
			default: ''
		}
	},
	methods: {
		resolvePath (routePath) {
			// if (isExternal(routePath)) {
			//   return routePath;
			// }
			// if (isExternal(this.basePath)) {
			//   return this.basePath;
			// }
			return path.resolve(this.basePath, routePath)
		},
		hasChildrenShow (arr) {
			return arr.length && arr.some(v => !v.hidden)
		},
		generateTitle
	}
}
</script>
